// extracted by mini-css-extract-plugin
export default {"wrapper":"wallet_wrapper__qD-Oc","walletIcon":"wallet_walletIcon__PytKA"};